module.exports = __webpack_public_path__ + "2e61f47d8161cd93ae5b7c44bad5bd5b.pdf";